<template>
  <div class="cart-drawer" :class="{ 'cart-drawer--show': showDrawer }">
    <!-- 遮罩层 -->
    <div class="cart-drawer__modal" @click="hiddenCart" />
    <div
      class="titlerightcart cart-drawer__body"
      :class="{ 'cart-drawer__body--dark': cartStyle == 'dark' }"
      id="titlerightcart"
    >
      <div class="cart_loading" v-if="cart_loading"></div>
      <div class="drawer_header">
        <h2 class="secondary_title">{{ $t('cart.your_cart') }}</h2>
        <button class="iconfont icon-cm-cancel-1-copy" @click="hiddenCart"></button>
      </div>
      <!-- <div class="drawer_inner" v-if="cart_product.length"> -->
      <div class="drawer_inner_main">
        <!-- 加入购物车的商品 -->
        <div style="position: relative">
          <div class="drawer_inner_main__inner" v-if="cartmes.cart_contents_count">
            <div
              class="drawer_inner_main_item"
              v-for="item in cartmes.cart"
              :key="item.key"
              :cart-product-id="item.product.ID"
              :class="{
                'free-box': item.wdr_free_product == 'Free',
              }"
            >
              <div class="drawer_inner_main_item_left">
                <a :href="item.product.path || item.product.public_url">
                  <img
                    :src="
                      item.variant
                        ? item.variant.feature_image
                          ? item.variant.feature_image.thumbnail
                          : item.product.feature_image
                          ? item.product.feature_image.thumbnail
                          : defaultImage
                        : item.product.feature_image
                        ? item.product.feature_image.thumbnail
                        : defaultImage
                    "
                    alt
                    :class="[themeStyleRadius == 'circle' ? 'image-radius' : '']"
                    @error.once="imageFailure($event, defaultImage)"
                  />
                </a>
              </div>
              <div class="drawer_inner_main_item_right">
                <p class="drawer_inner_main_item_right_name">
                  <a class="page_text_font" :href="item.product.path || item.product.public_url">{{
                    item.product.post_title
                  }}</a>
                </p>
                <p class="drawer_inner_main_item_right_variant" v-if="item.variant">
                  <template v-for="(subitem, subindex) in item.variant.attrs">
                    <span class="secondary_title" v-if="subitem.value != 'Default Title'" :key="subindex">{{
                      subitem.value
                    }}</span>
                  </template>
                </p>
                <template v-if="item.properties">
                  <template v-for="(subitem, subindex) in item.properties">
                    <p
                      class="drawer_inner_main_item_right_variant text-overflow-1"
                      v-if="subitem"
                      :key="subindex + subitem"
                    >
                      <span class="secondary_title">
                        {{ subindex }} :
                        <template v-if="subitem.search(/^https?:\/\//) == -1"> {{ subitem }} </template>
                        <a class="preview" v-else :href="subitem" @click.prevent="downloadFile(subitem, subitem)"
                          >Preview</a
                        >
                      </span>
                    </p>
                  </template>
                </template>
                <v-selectprice
                  :price="item.product.price - 0"
                  :appendToBody="false"
                  :disable_select="!(showCurrencySelector && currencySelectorType == 'global')"
                ></v-selectprice>

                <div class="drawer_inner_main_item_right_price">
                  <div>
                    <my-el-input-number
                      v-model="item.quantity"
                      :max="100000"
                      :precision="0"
                      :step="1"
                      step-strictly
                      size="mini"
                      @change="changequantity($event, item.key)"
                      :disabled="disabled_num"
                    ></my-el-input-number>
                  </div>
                  <div>
                    <span
                      style="cursor: pointer; fontsize: 12px; lineheight: 24px; padding: 5px; margin-right: -8px"
                      @click="!disabled_num && changequantity(0, item.key)"
                      class="iconfont icon-cm-cancel-1-copy"
                    ></span>
                  </div>
                </div>
              </div>
              <div class="free-item" v-if="item.wdr_free_product == 'Free'">
                <div class="free-label venue_sales_label">Giveaway</div>
                <div class="image-box">
                  <a :href="item.product.path || item.product.public_url">
                    <img
                      :src="
                        item.variant
                          ? item.variant.feature_image
                            ? item.variant.feature_image.thumbnail
                            : item.product.feature_image
                            ? item.product.feature_image.thumbnail
                            : defaultImage
                          : item.product.feature_image
                          ? item.product.feature_image.thumbnail
                          : defaultImage
                      "
                      alt
                      @error.once="imageFailure($event, defaultImage)"
                    />
                  </a>
                </div>
                <div class="text-box">
                  <p class="title">
                    <a class="page_text_font text-item" :href="item.product.path || item.product.public_url">{{
                      item.product.post_title
                    }}</a>
                  </p>
                  <p class="variant text-item" v-if="item.variant">
                    <template v-for="(subitem, subindex) in item.variant.attrs">
                      <span class="secondary_title" v-if="subitem.value != 'Default Title'" :key="subindex">
                        {{ subitem.value }}
                      </span>
                    </template>
                  </p>
                  <div id="free-price">
                    <v-selectprice
                      :price="(item.line_total / item.quantity).toFixed(2)"
                      :disable_select="true"
                      :fontSize="14"
                    ></v-selectprice>
                    <span class="secondary_title">x {{ item.quantity }} </span>
                  </div>
                </div>
              </div>
            </div>
            <v-cartnote
              v-if="cartNotOff"
              :cart_note="cartmes.cart_note"
              :note_content_style="{ width: '100%' }"
            ></v-cartnote>
          </div>
          <div class="page_text_font" v-else style="margin-top: 15px">
            <div class="cartEmpty">
              <img class="cartEmpty--image" :src="require('@/images/cartEmpty.png').default" alt />
              <span class="cartEmpty--text">{{ $t('cart.cart_empty') }}</span>
            </div>
          </div>
          <v-guess-like
            :comment="comment"
            v-if="recommended_product && show_recommended"
            :recommended_product="recommended_product"
            cart_type="inCart"
            :inline_cart="true"
            :hide_container="true"
            :product_id="product_ids"
            :show_currency_selector="false"
            theme="vogue"
            :beforeAdd="() => beforeAdd()"
            :onAdded="scrollerBack"
          />
        </div>
      </div>

      <div class="drawer_inner_foot" v-if="cartmes.cart_contents_count">
        <div class="drawer_inner_foot_price">
          <p class="secondary_title secondary_unset" >{{ $t('cart.subtotal') }}</p>
          <p>
            <v-selectprice
              :showCountryBefore="true"
              :country="$store.state.pricetype"
              :price="((cartmes.discount_cart || 0) + complete_subtotal).toFixed(2)"
              type="reverse"
              :appendToBody="false"
              :disable_select="!(showCurrencySelector && currencySelectorType == 'global')"
            ></v-selectprice>
          </p>
        </div>
        <div class="drawer_inner_foot_price" v-if="cartmes.discount_cart" id="discount_price">
          <p class="secondary_title" v-if="cartmes.coupons.length">
            <span class="iconfont icon-cm-biaoqian"></span>
            {{
              Object.values(cartmes.coupons)[0].description
                ? Object.values(cartmes.coupons)[0].description
                : Object.values(cartmes.coupons)[0].code
            }}
          </p>
          <p class="secondary_title secondary_unset" v-else >
            {{ $t('account.discount') }}
          </p>
          <p>
            <v-selectprice
              :showCountryBefore="true"
              :price="cartmes.discount_cart"
              :disable_select="true"
              :fontSize="14"
              class="secondary-minus"
              :country="$store.state.pricetype"
            ></v-selectprice>
          </p>
        </div>
        <div class="drawer_inner_foot_price" style="font-weight: 600">
          <p class="secondary_title secondary_unset" style="text-transform: capitalize !important; font-weight: 600">{{ $t('cart.total').toLowerCase() }}</p>
          <p>
            <v-selectprice
              :showCountryBefore="true"
              :country="$store.state.pricetype"
              :price="complete_subtotal"
              type="reverse"
              :appendToBody="false"
              :disable_select="true"
            ></v-selectprice>
          </p>
        </div>
        <div class="drawer_inner_foot--tip page_text_font">
          {{ $t('cart.Taxes_shipping_checkout') }}
        </div>
        <!-- <div class="drawer_inner_foot_info">Shipping, taxes, and discounts calculated at checkout.</div> -->
        <button
          class="checkout secondary_title main_button"
          :class="[{ button_active: checkout_active }, themeStyleRadius == 'circle' ? 'button-radius' : '']"
          :disabled="checkout_active"
          @click="checkout"
          type="button"
        >
          {{ $t('cart.check_out') }} →
        </button>
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import vGuessLike from '@/js/components/view/guesslike/guesslike'
import vCartnote from '@/js/components/common/cartnote.vue'
import myElInputNumber from '@/js/components/myElement/myElInputNumber.vue'
export default {
  props: {
    showDrawer: {},
    hiddenCart: {},
    cartStyle: {},
    cart_loading: {},
    cartmes: {},
    theme: {},
    showCurrencySelector: {},
    complete_subtotal: {},
    currencySelectorType: {},
    changequantity: {},
    checkout: {},
    themeStyleRadius: {},
    comment: {},
    beforeAdd: {},
    recommended_product: {},
    product_ids: {},
    cartNotOff: {},
    scrollerBack: {},
    show_recommended: {},
    disabled_num: {},
    checkout_active: {},
  },
  mounted(){
      const node = this.$mount().$el;
      document.body.appendChild(node);
  },
  components: {
    vGuessLike,
    vCartnote,
    myElInputNumber,
  },
}
</script>
<style scoped lang='scss'>
// 抽屉购物车
.cart-drawer {
  &--show {
    .cart-drawer {
      &__modal {
        display: block;
      }
      &__body {
        right: 0;
      }
    }
  }
  // 深色模式
  .cart-drawer__body--dark {
    filter: invert(1) hue-rotate(180deg);
    &::v-deep {
      &#titlerightcart {
        img {
          filter: invert(1) hue-rotate(180deg);
          transition: auto !important;
        }
        .checkout_flex,
        .starWrap,
        .checkout {
          filter: invert(1) hue-rotate(180deg);
        }
        .cart-currency-tip {
          filter: invert(1) hue-rotate(180deg);
          color: #fff;
          background: #ffa9457a;
          border: none;
        }
        .inline-guesslike-list_box {
          .add-card {
            background-color: #ccc;
          }
        }
        .drawer_inner_main
          .drawer_inner_main_item
          .drawer_inner_main_item_right
          .drawer_inner_main_item_right_price {
          .el-input-number {
            .el-input {
              .el-input__inner {
                background-color: #ccc !important;
                color: #000;
              }
            }
            .el-input-number__increase,
            .el-input-number__decrease {
              border: none !important;
            }
          }
        }
        .note_content {
          textarea {
            background-color: #ccc !important;
          }
        }
        .drawer_header h2,
        .drawer_header button,
        .drawer_inner_main_item_right_name a,
        .drawer_inner_main_item_right_variant span,
        .guess_title,
        .add-pro-title a,
        .add-bottom__btn,
        .inline-guesslike-list_box li.text-center,
        .drawer_inner_foot_price > .secondary_title,
        .note_content h4,
        .price_text {
          filter: invert(1) hue-rotate(180deg);
          color: #fff !important;
        }
      }
    }
  }
  &__modal {
    display: none;
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1031;
    background: #0000001f;
  }
  &__body {
    position: fixed;
    top: 0;
    right: -400px;
    width: 400px;
    height: 100%;
    z-index: 199;
    transition: right 0.3s;
    background-color: #fff;
  }
}
.titlerightcart {
  box-sizing: border-box;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  z-index: 1032;
  .cart_loading {
    display: block;
    width: 24px;
    height: 24px;
    position: absolute;
    left: 50%;
    top: 150px;
    margin-left: -12px;
    margin-top: -12px;
    border-radius: 50%;
    border: 3px solid #000;
    border-top-color: transparent;
    -webkit-animation: spin 1s infinite linear;
    -moz-animation: spin 1s infinite linear;
    -o-animation: spin 1s infinite linear;
    animation: spin 1s infinite linear;
  }
  .drawer_header {
    width: 100%;
    height: 80px;
    justify-content: space-between;
    border-bottom: 1px solid #000;
    h2 {
      display: inline-block;
      line-height: 80px;
      font-size: 24px;
      margin: 0;
    }
    button {
      height: 100%;
      float: right;
      border: none;
      background-color: transparent;
      font-size: 12px;
    }
  }
  // .drawer_inner {
  //   flex: 1;
  //   flex-direction: column;
  //   display: flex;
  .drawer_inner_main {
    flex: 1;
    margin-right: -24px;
    padding-right: 24px;
    // height: calc(100vh - 269px);
    overflow-y: auto;
    .currency-tips {
      color: rgba(0, 0, 0, 0.65);
      border: 1px solid #ffe58f;
      background-color: #fffbe6;
      padding: 8px 12px;
      margin-bottom: 12px;
    }
    .drawer_inner_main_item {
      padding-top: 30px;
      padding-bottom: 30px;
      // border-bottom: 1px solid #3a3a3a;
      .drawer_inner_main_item_left {
        display: inline-block;
        padding-left: 15px;
        margin-left: -15px;
        width: 25%;
        vertical-align: top;
        img {
          max-width: 100%;
        }
      }
      .drawer_inner_main_item_right {
        width: 75%;
        display: inline-block;
        padding-left: 12px;
        .drawer_inner_main_item_right_name {
          opacity: 0.9;
          a {
            line-height: 1;
            font-size: 17px;
            color: #3a3a3a;
            text-decoration: none;
            &:hover {
              text-decoration: underline;
            }
          }
        }
        .drawer_inner_main_item_right_variant {
          opacity: 0.9;
          span {
            font-size: 15px;
            color: #3a3a3a;
          }
          & > span:not(:last-child)::after {
            content: ' / ';
          }
          .preview:hover {
            opacity: 0.7;
            cursor: pointer;
          }
        }
        p {
          margin-bottom: 0;
        }
        .drawer_inner_main_item_right_price {
          margin-top: 8px;
          display: flex;
          & > div {
            flex: 1;
          }
          div:last-child {
            text-align: right;
          }
          &::v-deep .el-input-number {
            width: 90px;
            line-height: 30px;
            height: 30px;
            .el-input-number__decrease,
            .el-input-number__increase {
              background-color: transparent !important;
              border-radius: 0;
              width: 30px;
              height: 30px;
              color: #3a3a3a !important;
              &:hover {
                background-color: #000 !important;
                i {
                  color: white;
                }
              }
            }
            .el-input-number__decrease {
              border-right: 1px solid #f0f0f0 !important;
            }
            .el-input-number__increase {
              border-left: 1px solid #f0f0f0 !important;
            }
            .el-input {
              .el-input__inner {
                background-color: transparent !important;
                border-radius: 0;
                border: 1px solid #f0f0f0;
                padding-left: 23px;
                padding-right: 23px;
                height: 30px;
                line-height: 30px;
                font-size: 13px;
                font-weight: 600;
              }
            }
          }
        }
      }
      &:last-child {
        border-bottom: unset;
      }
    }
    .free-box {
      background: #fafafa;
      padding: 10px 0;
      .drawer_inner_main_item_left,
      .drawer_inner_main_item_right {
        display: none !important;
      }
      .free-item {
        width: 280px;
        min-height: 70px;
        margin-left: 10px;
        display: flex;
        align-content: center;
        background: #fff;
        .free-label {
          position: absolute;
          width: 70px;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 3px;
          box-sizing: border-box;
          border-radius: 28px;
          font-size: 9px;
        }
        .image-box {
          width: 90px;
          display: flex;
          align-items: center;
          margin-right: 15px;
          margin-left: 10px;
          padding: 10px 0;
          a {
            display: flex;
            align-items: center;
            width: 70px;
            height: 100%;
            img {
              width: 100%;
              max-height: 100%;
            }
          }
        }
        .text-box {
          display: flex;
          align-items: baseline;
          flex-direction: column;
          justify-content: space-evenly;
          width: 100%;
          .title {
            margin-bottom: 10px;
          }
          .variant {
            margin-bottom: 0;
            & > span:not(:last-child)::after {
              content: ' / ';
            }
          }
          .text-item {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            line-height: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            text-overflow: -o-ellipsis-lastline;
          }
          #free-price {
            font-size: 12px;
            color: #222222;
            &::v-deep {
              .product_price_price {
                .money {
                  font-size: 12px !important;
                  color: #222222 !important;
                }
              }
            }
          }
        }
      }
    }
  }
  .drawer_inner_foot {
    // height: 158px;
    border-top: 1px solid #dddddd;
    padding-top: 15px;
    color: #3a3a3a;
    padding-bottom: 30px;
    &--tip {
      font-size: 14px;
      text-align: left;
      text-transform: initial;
      word-wrap: break-word;
      margin: 10px 0 20px 0;
      line-height: 1.5;
    }
    .drawer_inner_foot_price {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 15px;
      word-break: break-word;
      &:nth-child(3){
          padding-top: 10px;
          border-top: 1px solid #DDDDDD;
      }
      &::v-deep {
        .selectpricewrap {
          .pricelistbox {
            right: 45px;
          }
        }
      .secondary-minus .price_text{
        &::before {
          content: "-";
        }
      }
      }
      #discount_price p {
        font-size: 14px;
        color: #8e929e;
        .selectpricewrap {
          & > span {
            color: green;
          }
        }
      }
      p {
        margin: 0;
        flex: 1;
      }
      p:first-child {
        font-size: 14px;
        margin: 0;
        font-weight: 500;
        font-style: normal;
        letter-spacing: 0.1em;
        text-transform: uppercase;
      }
      p:last-child {
        text-align: right;
      }
      .secondary_unset {
        text-transform: unset !important;
      }
    }
    .drawer_inner_foot_info {
      text-align: center;
      font-size: 15px;
      color: #3a3a3a;
      margin-bottom: 15px;
      opacity: 0.7;
    }
    .checkout {
      width: 100%;
      display: inline-block;
      padding: 12px 20px;
      border: none;
      background: rgb(201, 13, 13) !important;
      color: white;
      font-weight: 600;
      font-style: normal;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      font-size: 13px;
      border-radius: 0;
      cursor: pointer;
      &:hover {
        background: rgb(241, 34, 34) !important;
      }
    }
  }
  .guess_like {
    .guess_list_wrap {
      .guess_list_hidden {
        .inline-guesslike-list_box {
          .add-card {
            background-color: #e0e0e0;
            .all-option-select {
              z-index: unset;
              border-color: #999;
            }
          }
        }
      }
    }
  }
  // }
}
#app {
  position: relative;
  right: 0;
  transition: right 0.3s;
  &.js-show-cart-drawer {
    right: 400px;
  }
  .headbox .titleright {
    .has_child_menu:hover {
      color: black !important;
      li a {
        color: black !important;
      }
    }
  }
}
@media screen and(max-width: 590px) {
  #app {
    &.js-show-cart-drawer {
      right: 300px;
    }
  }
  .cart-drawer {
    &__body {
      width: 300px;
      right: -300px;
    }
    .titlerightcart {
      padding: 0 15px;
    }
  }
  .free-box .free-item {
    width: 230px !important;
    .image-box {
      max-width: 50px !important;
    }
    .free-label {
      width: 65px !important;
      font-size: 10px !important;
    }
  }
}
.cartEmpty {
  margin: 80px auto;
  width: max-content;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  &--image {
    margin-bottom: 20px;
  }
}
</style>